import { memo } from "react";

const JoinUsLink = ({ link, bg }) => {
  // console.log(...props);
  return (
    <a
      href={link}
      className="inline-block mr-8px md:mr-24px last:mr-0"
      target="_blank"
      rel="noreferrer"
    >
      <div className={`w-48px h-48px md:w-80px md:h-80px bg-cover ${bg}`}></div>
    </a>
  );
};

const JoinUs = () => {
  return (
    <div className="mt-64px md:mt-112px" id="joinUs">
      <h2 className="text-26px md:text-4xl font-semibold text-green-1 text-center pb-8px md:pb-16px">
        加入我們
      </h2>
      <div className="flex justify-center pb-24px md:pb-40px">
        <JoinUsLink
          link={"https://meteor.today/board/all"}
          bg={"bg-meteorIcon hover:bg-meteorHoverIcon"}
        />
        <JoinUsLink
          link={
            "https://www.youtube.com/channel/UCPPGQ3WpK7B8IYRYe4pUt-Q/videos"
          }
          bg={"bg-youtubeIcon hover:bg-youtubeHoverIcon"}
        />
        <JoinUsLink
          link={
            "https://www.instagram.com/meteor.tw/?utm_source=ig_embed&ig_rid=aeaf5406-9fcf-409d-8784-777d50be9118"
          }
          bg={"bg-igIcon hover:bg-igHoverIcon"}
        />
        <JoinUsLink
          link={
            "https://line.me/ti/g2/nBT3ktOIp-nyz1tP9XQjTY_-6dA689v43sph-g?utm_source=invitation&utm_medium=link_copy&utm_campaign=default"
          }
          bg={"bg-lineIcon hover:bg-lineHoverIcon"}
        />
        <JoinUsLink
          link={"https://www.facebook.com/MeteorApp/"}
          bg={"bg-facebookIcon hover:bg-facebookHoverIcon"}
        />
        <JoinUsLink
          link={"https://www.tiktok.com/@meteor.tw?lang=en"}
          bg={"bg-tiktokIcon hover:bg-tiktokHoverIcon"}
        />
      </div>
    </div>
  );
};

export default memo(JoinUs);
